// Generated by LiveScript 1.6.0
var ref$, id, log, map, filter, scroll, round, pub, sub, enableSpying, $window, $document, Scroller;
ref$ = require('utils'), id = ref$.id, log = ref$.log, map = ref$.map, filter = ref$.filter, scroll = ref$.scroll, round = ref$.round;
ref$ = require('pubsub'), pub = ref$.pub, sub = ref$.sub, enableSpying = ref$.enableSpying;
$window = $(window);
$document = $(document);
module.exports = Scroller = (function(){
  Scroller.displayName = 'Scroller';
  var firefoxErrorMargin, logScroller, plog, prototype = Scroller.prototype, constructor = Scroller;
  firefoxErrorMargin = 2;
  logScroller = false;
  plog = logScroller ? log : id;
  enableSpying();
  function Scroller(){
    var this$ = this;
    this.offsetOf = bind$(this, 'offsetOf', prototype);
    this.sections = $('[data-scroll-anchor]');
    this.headerHeightOffset = $('header').outerHeight();
    this.sectionOffsets = map(this.offsetOf, map($, this.sections.toArray()));
    this.listeners = [];
    this.currentSectionName = '';
    this.isScrolling = false;
    this.callbacks = {
      sectionChange: id
    };
    $window.on('scroll', function(){
      var top, half, thisSection, i$, ref$, len$, λ, results$ = [];
      top = $window.scrollTop();
      half = top / ($document.height() - window.innerHeight);
      thisSection = this$.nameOfSectionAt(top);
      if (this$.currentSectionName !== thisSection) {
        this$.callbacks.sectionChange(thisSection, this$.getSectionByName(thisSection));
        pub('section-visible', thisSection);
        if (!this$.isScrolling) {
          pub('section-changed', thisSection);
        }
        this$.currentSectionName = thisSection;
      }
      for (i$ = 0, len$ = (ref$ = this$.listeners).length; i$ < len$; ++i$) {
        λ = ref$[i$];
        results$.push(λ.apply(this$, [top, half]));
      }
      return results$;
    });
  }
  Scroller.prototype.belongsToSection = function(y){
    var i$, ref$, len$, ix, o;
    for (i$ = 0, len$ = (ref$ = this.sectionOffsets).length; i$ < len$; ++i$) {
      ix = i$;
      o = ref$[i$];
      if (y <= o - firefoxErrorMargin) {
        return ix - 1;
      }
    }
    return this.sectionOffsets.length - 1;
  };
  Scroller.prototype.nameOfSectionAt = function(offset){
    this.sectionOffsets = this.sections.toArray().map($).map(this.offsetOf).map(round);
    return this.sections.eq(this.belongsToSection(offset)).data('scroll-anchor');
  };
  Scroller.prototype.getSectionByName = function(sectionName){
    sectionName == null && (sectionName = '');
    plog("Scroller::get-section-by-name", sectionName);
    return this.sections.filter(function(){
      return sectionName === $(this).data('scroll-anchor');
    });
  };
  Scroller.prototype.offsetOf = function($section){
    plog("Scroller::offset-of", $section, $section.data('scroll-anchor'));
    if ($section.exists()) {
      return $section.offset().top - this.headerHeightOffset;
    } else {
      return 0;
    }
  };
  Scroller.prototype.onScroll = function(λ){
    plog("Scroller::on-scroll");
    return this.listeners.push(λ);
  };
  Scroller.prototype.scrollTo = function(section, speed){
    var targetOffset, this$ = this;
    speed == null && (speed = 600);
    this.isScrolling = true;
    targetOffset = this.offsetOf(this.getSectionByName(section));
    plog("Scroller::scroll-to", section, round(targetOffset));
    return scroll(round(targetOffset), speed, function(){
      return this$.isScrolling = false;
    });
  };
  Scroller.prototype.scrollToIfDifferent = function(section, speed){
    if (section == null) {
      return;
    }
    plog("Scroller::scroll-to-if-different", section);
    if (this.currentSectionName !== section) {
      return this.scrollTo(section, speed);
    }
  };
  Scroller.prototype.readInitialUrl = function(force){
    var url;
    force == null && (force = false);
    plog("Scroller::read-initial-url");
    url = filter(id, location.pathname.split('/'));
    this.scrollToIfDifferent(url[0]);
    return url[0] || "";
  };
  Scroller.prototype.onSectionChange = function(λ){
    return this.callbacks.sectionChange = λ;
  };
  return Scroller;
}());
function bind$(obj, key, target){
  return function(){ return (target || obj)[key].apply(obj, arguments) };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjcm9sbGVyLmxzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0EsSUFBQSxHQUEwQyxPQUExQyxDQUFrRCxPQUFBLENBQWxELEVBQUUsRUFBc0MsQ0FBQSxDQUFBLENBQXhDLElBQUEsQ0FBQSxFQUFBLEVBQU0sR0FBa0MsQ0FBQSxDQUFBLENBQXhDLElBQUEsQ0FBQSxHQUFBLEVBQVcsR0FBNkIsQ0FBQSxDQUFBLENBQXhDLElBQUEsQ0FBQSxHQUFBLEVBQWdCLE1BQXdCLENBQUEsQ0FBQSxDQUF4QyxJQUFBLENBQUEsTUFBQSxFQUF3QixNQUFnQixDQUFBLENBQUEsQ0FBeEMsSUFBQSxDQUFBLE1BQUEsRUFBZ0MsS0FBUSxDQUFBLENBQUEsQ0FBeEMsSUFBQSxDQUFBO0FBQ0EsSUFBQSxHQUE2QixPQUE3QixDQUFxQyxRQUFBLENBQXJDLEVBQUUsR0FBeUIsQ0FBQSxDQUFBLENBQTNCLElBQUEsQ0FBQSxHQUFBLEVBQU8sR0FBb0IsQ0FBQSxDQUFBLENBQTNCLElBQUEsQ0FBQSxHQUFBLEVBQVksWUFBZSxDQUFBLENBQUEsQ0FBM0IsSUFBQSxDQUFBO0FBRUEsT0FBVSxDQUFBLENBQUEsQ0FBRSxFQUFFLE1BQUQ7QUFDYixTQUFVLENBQUEsQ0FBQSxDQUFFLEVBQUUsUUFBRDtBQU9iLE1BQU0sQ0FBQyxPQUFRLENBQUEsQ0FBQSxDQUFRLFlBQU4sUUFBQSxDQUFBOzs7RUFFZixrQkFBcUIsQ0FBQSxDQUFBLENBQUU7RUFDdkIsV0FBYSxDQUFBLENBQUEsQ0FBRTtFQUVmLElBQUssQ0FBQSxDQUFBLENBQUssWUFBYSxFQUFLLElBQUksRUFBSztFQUVyQyxhQUFZO0VBRVosUUFBQSxDQUFBLFFBQUEsQ0FBQTs7U0F3Q0E7SUF2Q0UsSUFBQyxDQUFBLFFBQXFCLENBQUEsQ0FBQSxDQUFFLEVBQUUsc0JBQUQ7SUFDekIsSUFBQyxDQUFBLGtCQUFxQixDQUFBLENBQUEsQ0FBRSxFQUFFLFFBQUQsQ0FBVSxDQUFDLFlBQVk7SUFDaEQsSUFBQyxDQUFBLGNBQXFCLENBQUEsQ0FBQSxDQUFFLElBQUksSUFBQyxDQUFBLFVBQVcsSUFBSSxHQUFHLElBQUMsQ0FBQSxRQUFRLENBQUMsUUFBUSxDQUFyQixDQUFoQjtJQUM1QixJQUFDLENBQUEsU0FBcUIsQ0FBQSxDQUFBLENBQUU7SUFDeEIsSUFBQyxDQUFBLGtCQUFxQixDQUFBLENBQUEsQ0FBRTtJQUN4QixJQUFDLENBQUEsV0FBcUIsQ0FBQSxDQUFBLENBQUU7SUFFeEIsSUFBQyxDQUFBLFNBQVUsQ0FBQSxDQUFBLENBQ1Q7TUFBQSxlQUFnQjtJQUFoQjtJQUVGLE9BQU8sQ0FBQyxHQUFHLFVBQVMsUUFBQSxDQUFBOztNQUNsQixHQUFLLENBQUEsQ0FBQSxDQUFFLE9BQU8sQ0FBQyxVQUFVO01BQ3pCLElBQUssQ0FBQSxDQUFBLENBQUUsR0FBSSxDQUFBLENBQUEsQ0FBRSxDQUFDLFNBQVMsQ0FBQyxNQUFRLENBQUYsQ0FBRSxDQUFBLENBQUEsQ0FBRSxNQUFNLENBQUMsV0FBWTtNQUNyRCxXQUFhLENBQUEsQ0FBQSxDQUFFLEtBQUMsQ0FBQSxnQkFBbUIsR0FBQTtNQUVuQyxJQUFHLEtBQUMsQ0FBQSxrQkFBcUIsQ0FBQSxHQUFBLENBQUssV0FBOUI7UUFDRSxLQUFDLENBQUEsU0FBUyxDQUFDLGNBQWUsYUFBYyxLQUFDLENBQUEsaUJBQW9CLFdBQUEsQ0FBbkM7UUFDMUIsSUFBSSxtQkFBbUIsV0FBbkI7UUFDSixJQUFBLENBQU8sS0FBQyxDQUFBLFdBQVI7VUFDRSxJQUFJLG1CQUFtQixXQUFuQjs7UUFDTixLQUFDLENBQUEsa0JBQXFCLENBQUEsQ0FBQSxDQUFFOztNQUUxQixvRUFBQTtRQUFJO3NCQUNGLENBQUMsQ0FBQyxNQUFNLE9BQU0sQ0FBRSxLQUFLLElBQVAsQ0FBTjs7O0tBYkQ7O3FCQWViLG1CQUFvQixRQUFBLENBQUEsQ0FBQTs7SUFDbEIsd0VBQUE7O01BQUk7TUFDRixJQUFHLENBQUUsQ0FBQSxFQUFBLENBQUcsQ0FBRSxDQUFBLENBQUEsQ0FBRSxrQkFBWjtRQUNFLE1BQUEsQ0FBTyxFQUFHLENBQUEsQ0FBQSxDQUFFLENBQVo7OztJQUNKLE1BQUEsQ0FBTyxJQUFDLENBQUEsY0FBZSxDQUFDLE1BQU8sQ0FBQSxDQUFBLENBQUUsQ0FBakM7O3FCQUVGLGtCQUFvQixRQUFBLENBQUEsTUFBQTtJQUNsQixJQUFDLENBQUEsY0FBZ0IsQ0FBQSxDQUFBLENBQUUsSUFBQyxDQUFBLFFBQVEsQ0FBQyxRQUFRLENBQUUsQ0FBQyxJQUFJLENBQUEsQ0FBRSxDQUFDLElBQUksSUFBQyxDQUFBLFFBQUQsQ0FBVyxDQUFDLElBQUksS0FBQTtXQUNuRSxJQUFDLENBQUEsUUFBUSxDQUFDLEdBQUksSUFBQyxDQUFBLGlCQUFtQixNQUFBLENBQXRCLENBQThCLENBQUMsS0FBSyxlQUFBOztxQkFFbEQsbUJBQXFCLFFBQUEsQ0FBQSxXQUFBO0lBQUMsd0JBQUEsY0FBZTtJQUNuQyxLQUFvQyxpQ0FBRSxXQUFGO1dBQ3BDLElBQUMsQ0FBQSxRQUFRLENBQUMsT0FBTyxRQUFBLENBQUE7YUFBRyxXQUFhLENBQUEsR0FBQSxDQUFHLENBQUgsQ0FBSyxJQUFELENBQU0sQ0FBQyxJQUFYLENBQWdCLGVBQUE7S0FBaEM7O3FCQUVuQixXQUFXLFFBQUEsQ0FBQSxRQUFBO0lBQ1QsS0FBMEIsdUJBQUUsVUFBVSxRQUFRLENBQUMsS0FBSyxlQUFBLENBQTFCO0lBQzFCLElBQUcsUUFBUSxDQUFDLE1BQVosQ0FBa0IsQ0FBbEI7YUFDRSxRQUFRLENBQUMsTUFBVyxDQUFMLENBQUMsQ0FBQSxHQUFJLENBQUEsQ0FBQSxDQUFFLElBQUMsQ0FBQTtLQUN6QjthQUNFOzs7cUJBRUosV0FBVyxRQUFBLENBQUEsQ0FBQTtJQUNULEtBQTBCLHFCQUFBO1dBQzFCLElBQUMsQ0FBQSxTQUFTLENBQUMsS0FBSyxDQUFBOztxQkFFbEIsV0FBVyxRQUFBLENBQUEsT0FBQSxFQUFBLEtBQUE7O0lBQVUsa0JBQUEsUUFBUTtJQUMzQixJQUFDLENBQUEsV0FBYSxDQUFBLENBQUEsQ0FBRTtJQUNoQixZQUFjLENBQUEsQ0FBQSxDQUFFLElBQUMsQ0FBQSxTQUFVLElBQUMsQ0FBQSxpQkFBb0IsT0FBQSxDQUFyQjtJQUMzQixLQUEwQix1QkFBRSxTQUFTLE1BQU0sWUFBQSxDQUFqQjtXQUMxQixPQUFRLE1BQU0sWUFBQSxHQUFnQixPQUFPLFFBQUEsQ0FBQTthQUFHLEtBQUMsQ0FBQSxXQUFhLENBQUEsQ0FBQSxDQUFFO0tBQWpEOztxQkFFVCxzQkFBd0IsUUFBQSxDQUFBLE9BQUEsRUFBQSxLQUFBO0lBQ2YsSUFBTyxPQUFKLFFBQUg7TUFBUCxNQUFBOztJQUNBLEtBQXVDLG9DQUFFLE9BQUY7SUFDdkMsSUFBRyxJQUFDLENBQUEsa0JBQXFCLENBQUEsR0FBQSxDQUFLLE9BQTlCO2FBQ0UsSUFBQyxDQUFBLFNBQVUsU0FBUyxLQUFUOzs7cUJBRWYsaUJBQWtCLFFBQUEsQ0FBQSxLQUFBOztJQUFDLGtCQUFBLFFBQVE7SUFDekIsS0FBaUMsNEJBQUE7SUFDakMsR0FBSSxDQUFBLENBQUEsQ0FBRSxPQUFPLElBQUksUUFBUSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEdBQUEsQ0FBNUI7SUFDYixJQUFDLENBQUEsb0JBQXVCLEdBQUcsQ0FBQyxDQUFELENBQUg7SUFDeEIsTUFBQSxDQUFPLEdBQUcsQ0FBQyxDQUFELENBQUcsQ0FBQSxFQUFBLENBQUcsRUFBaEI7O3FCQUVGLGtCQUFtQixRQUFBLENBQUEsQ0FBQTtXQUNqQixJQUFDLENBQUEsU0FBUyxDQUFDLGFBQWUsQ0FBQSxDQUFBLENBQUUiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

